import React from "react";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { Container, Stack, Typography, Card } from '@mui/material';

// components
import Page from 'components/Page';
// services
import { createHoliday } from "services/holiday.service";

import HolidayForm from "./HolidayForm";

const CreateHolidayForm = () => {
  const history = useHistory();
  const selectedOrg = useSelector((state) => state.userData?.orgId);

  const submitHoliday = useMutation(values => {
    return createHoliday({values: {...values, organizationId: selectedOrg}});
  });

  const onSubmitHoliday = (values) => {
    submitHoliday.mutate(values, {
      onSuccess: (res) => {
        if (res) {
          history.goBack();
        }
      }
    });
  }

  return (
    <Page title="Holiday">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Create Holiday
          </Typography>
        </Stack>

        <Card>
          <HolidayForm 
            onSubmit={onSubmitHoliday}
          />
        </Card>
      </Container>
    </Page>
  );
}

export default CreateHolidayForm;